export default ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday']